export default __webpack_public_path__ + "992aef2d08f9b4f7ebf9ec212808a195.png";